import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: API_BASE });

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('chartaudit_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('chartaudit_token');
      localStorage.removeItem('chartaudit_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const getProfile = () => api.get('/auth/me');
export const uploadLogo = (formData) =>
  api.post('/auth/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// Documents
export const uploadDocument = (formData) =>
  api.post('/documents', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getDocuments = () => api.get('/documents');

// Audits
export const startAudit = (data) => api.post('/audits', data);
export const getAudits = () => api.get('/audits');
export const getAudit = (id) => api.get(`/audits/${id}`);
export const downloadAuditPdf = (id) => api.get(`/audits/${id}/pdf`, { responseType: 'blob' });

// Admin
export const getAdminStats = () => api.get('/admin/stats');
export const getAdminAgencies = () => api.get('/admin/agencies');
export const toggleAgencyStatus = (id, isActive) => api.patch(`/admin/agencies/${id}/status`, { isActive });
export const getPendingUsers = () => api.get('/admin/pending-users');
export const approveUser = (id) => api.patch(`/admin/users/${id}/approve`);
export const rejectUser = (id) => api.patch(`/admin/users/${id}/reject`);
export const getAdminAudits = (params = {}) => api.get('/admin/audits', { params });

export default api;
